import React from 'react'
import { connect } from 'react-redux'

import AllFans from './AllFans'
import Segments from './Segments'

const FansPage = ({
  segments,
  match
}) => (
  <div className="segmenting container content">
    <AllFans match={match} />
    <h2>Saved Segments</h2>
    <Segments segments={segments} />
  </div>
)

function mapStateToProps(state) {
  return { segments: state.segments }
}

export default connect(mapStateToProps)(FansPage)


// WEBPACK FOOTER //
// ./src/components/FansPage.js